import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_forex_data_source_hdr_RowClass } from '../../../dbschema';

export class ForexDataSourceContainerModel extends BaseContainerModel {
  bl_fi_forex_data_source_hdr: bl_fi_forex_data_source_hdr_RowClass = new bl_fi_forex_data_source_hdr_RowClass();
}
